import CodeIcon from '@material-ui/icons/Code';
import React from 'react';
import { useApp } from '@backstage/core-plugin-api';

const ScmIntegrationIcon = (props) => {
  const { type } = props;
  const app = useApp();
  const DefaultIcon = CodeIcon;
  const Icon = type ? app.getSystemIcon(type) ?? DefaultIcon : DefaultIcon;
  return /* @__PURE__ */ React.createElement(Icon, null);
};

export { ScmIntegrationIcon };
//# sourceMappingURL=ScmIntegrationIcon.esm.js.map
